export default [
  {
    id: 1,
    name: '0～49'
  },
  {
    id: 2,
    name: '50～99'
  },
  {
    id: 3,
    name: '100～249'
  },
  {
    id: 4,
    name: '250～499'
  },
  {
    id: 5,
    name: '500～999'
  },
  {
    id: 6,
    name: '1000 以上'
  }
]
